export default {
  en: {
    inputInformation: 'Personal Information'
  },
  ja: {
    inputInformation: '情報入力'
  }
}
